import ReservationService from '@/services/reservation.service'

const DEFAULT_FILTERS = {
  store_id: null,
  warehouse_id: null,
  search: '',
  product_type: '',
  status: 'active',
  sort: 'desc',
  sort_by: '',
  sort_order: 'desc',
}

export default {
  namespaced: true,
  state: () => ({
    filters: { ...DEFAULT_FILTERS },
    pagination: { page: 1, limit: 10, total: 0 },
    items: [],
    warehouses: [],
    viewpoint: null,
    loading: { list: false, warehouses: false },
    error: null,
  }),
  mutations: {
    SET_FILTER(state, patch) {
      state.filters = { ...state.filters, ...patch }
      state.pagination.page = 1
    },
    RESET_FILTERS(state) {
      state.filters = { ...DEFAULT_FILTERS }
      state.pagination.page = 1
    },
    SET_PAGE(state, page) {
      state.pagination.page = page
    },
    SET_LIMIT(state, limit) {
      state.pagination.limit = limit
      state.pagination.page = 1
    },
    SET_ITEMS(state, { items, total, viewpoint }) {
      state.items = items
      state.pagination.total = total
      state.viewpoint = viewpoint || null
    },
    SET_WAREHOUSES(state, warehouses) {
      state.warehouses = warehouses
    },
    SET_LOADING(state, { key, value }) {
      state.loading = { ...state.loading, [key]: value }
    },
    SET_ERROR(state, error) {
      state.error = error
    },
  },
  actions: {
    async fetchWarehouses({ commit, state }) {
      if (!state.filters.store_id) {
        commit('SET_WAREHOUSES', [])
        return
      }
      commit('SET_LOADING', { key: 'warehouses', value: true })
      try {
        const res = await ReservationService.listWarehouses(state.filters.store_id)
        const payload = (res && res.data) || {}
        commit('SET_WAREHOUSES', payload.data || [])
      } catch (e) {
        commit('SET_ERROR', e.message || 'failed to fetch warehouses')
      } finally {
        commit('SET_LOADING', { key: 'warehouses', value: false })
      }
    },
    async fetchList({ commit, state }) {
      if (!state.filters.store_id || !state.filters.warehouse_id) {
        commit('SET_ITEMS', { items: [], total: 0, viewpoint: null })
        return
      }
      commit('SET_LOADING', { key: 'list', value: true })
      commit('SET_ERROR', null)
      try {
        const res = await ReservationService.listProducts({
          ...state.filters,
          page: state.pagination.page,
          limit: state.pagination.limit,
        })
        const payload = (res && res.data) || {}
        commit('SET_ITEMS', {
          items: payload.data || [],
          total: payload.total_rows != null ? payload.total_rows : (payload.total || 0),
          viewpoint: payload.viewpoint_cnt || null,
        })
      } catch (e) {
        const code = e.response && e.response.data && e.response.data.code
        commit('SET_ERROR', code || e.message || 'failed to fetch products')
        commit('SET_ITEMS', { items: [], total: 0, viewpoint: null })
      } finally {
        commit('SET_LOADING', { key: 'list', value: false })
      }
    },
    setFilter({ commit, dispatch, state }, patch) {
      const prevStore = state.filters.store_id
      commit('SET_FILTER', patch)
      if (patch.store_id !== undefined && patch.store_id !== prevStore) {
        commit('SET_FILTER', { warehouse_id: null })
        dispatch('fetchWarehouses')
      }
      dispatch('fetchList')
    },
    setPage({ commit, dispatch }, page) {
      commit('SET_PAGE', page)
      dispatch('fetchList')
    },
    setLimit({ commit, dispatch }, limit) {
      commit('SET_LIMIT', limit)
      dispatch('fetchList')
    },
    resetFilters({ commit }) {
      commit('RESET_FILTERS')
      commit('SET_ITEMS', { items: [], total: 0, viewpoint: null })
      commit('SET_WAREHOUSES', [])
    },
  },
}
